<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
    <div class="container">
     <div class="">
      <div class="row mt-2 mt-md-0">
  
          <aside class="col-sm-6 col-md-4 col-lg-3">
            <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
                      </aside>
                      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
                        <app-userheading-section></app-userheading-section>
                          <form action="" method="" enctype="">
        
          <div class="profile-content p-4">
          
              <div class="row">
              <div class="col-md-6 mb-2">
              <label for="firstName">New Password</label>
              <input type="hidden" class="form-control" id="" name="" value="">
              <input type="password" class="form-control" id="" name="" placeholder="New Password" required="">
              
              </div>
              <div class="col-md-6 mb-3">
              <label for="lastName">Re-password</label>
              <input type="password" class="form-control" name="" id="" placeholder="Re-enter password" required="">
              
              </div>
              </div>
              <button type="button" class="btn btn-primary comm-btn">Reset Password</button>
          </div>
             
  </form>
  
  
                      </div>
                  </div>
              </div>
          </div>
      </section>